<template>
    <div>
        <b-overlay :show="loading" :variant="'light'" :opacity="0.85" :blur="'2px'" rounded="sm">
            <b-card title="Create a new DocPusher website" class="mb-2">
                <b-form @submit="on_form_submit" @submit.stop.prevent>
                    <b-card-text>
                        <b-input-group prepend="DocPusher Subdomain" class="mb-2 mr-sm-2 mb-sm-0" append=".docpusher.com">
                            <b-input placeholder="mywebsite" v-debounce:500ms="check_subdomain" v-model="subdomain" :state="_subdomain_valid" id="subdomain" autofocus></b-input>
                        </b-input-group>
                        <b-form-invalid-feedback :state="_subdomain_valid">
                            {{subdomain_error}}
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="_subdomain_valid">
                            Nice choice. <code>https://{{subdomain}}.docpusher.com</code> will be your site's URL when you create it.
                        </b-form-valid-feedback>
                    </b-card-text>
                    <hr />
                    <div v-if="_subdomain_valid">
                        <b-alert style="text-align: center" show v-if="!theme" variant="info">
                            <i class="fas fa-info-circle"></i> Please select a theme for your new website.
                        </b-alert>
                        <b-alert style="text-align: center" show v-if="theme" variant="success">
                            <i class="fas fa-check"></i> Great choice.
                        </b-alert>
                        <div class="card-columns">
                            <!-- Minima theme -->
                            <b-card title="Minima" :img-src="require('@/assets/themes/minima.png')" img-alt="Minima theme" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                                <b-card-text>
                                    Minima is a basic, clean, one-size-fits-all theme for writers.
                                </b-card-text>
                                <div>
                                    <b-button block class="mb-2" href="#" variant="success" v-if="theme === 'minima'">
                                        <i class="far fa-check-circle"></i> Selected Theme
                                    </b-button>
                                    <b-button block class="mb-2" href="#" variant="primary" v-on:click="select_theme('minima')" v-else>
                                        <i class="far fa-square"></i> Select Theme
                                    </b-button>
                                </div>
                                <b-button-group block style="width: 100%">
                                    <b-button href="https://jekyll.github.io/minima/" target="_blank" variant="secondary">
                                        <i class="fas fa-external-link-alt"></i> Demo
                                    </b-button>
                                    <b-button href="https://github.com/jekyll/minima" target="_blank" variant="secondary">
                                        <i class="fas fa-info-circle"></i> More Info
                                    </b-button>
                                </b-button-group>
                            </b-card>
                            <!-- Neo-HPSTR theme -->
                            <b-card title="Neo-HPSTR" :img-src="require('@/assets/themes/neo-hpstr.png')" img-alt="Minima theme" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                                <b-card-text>
                                    Neo-HPSTR is a responsive and modern blog theme.
                                </b-card-text>
                                <div>
                                    <b-button block class="mb-2" href="#" variant="success" v-if="theme === 'neo-hpstr'">
                                        <i class="far fa-check-circle"></i> Selected Theme
                                    </b-button>
                                    <b-button block class="mb-2" href="#" variant="primary" v-on:click="select_theme('neo-hpstr')" v-else>
                                        <i class="far fa-square"></i> Select Theme
                                    </b-button>
                                </div>
                                <b-button-group block style="width: 100%">
                                    <b-button href="http://aronbordin.com/neo-hpstr-jekyll-theme/" target="_blank" variant="secondary">
                                        <i class="fas fa-external-link-alt"></i> Demo
                                    </b-button>
                                    <b-button href="https://github.com/aron-bordin/neo-hpstr-jekyll-theme" target="_blank" variant="secondary">
                                        <i class="fas fa-info-circle"></i> More Info
                                    </b-button>
                                </b-button-group>
                            </b-card>
                            <!-- MatJek theme -->
                            <b-card title="MatJek" :img-src="require('@/assets/themes/matjek.png')" img-alt="Minima theme" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                                <b-card-text>
                                    A responsive Material theme based on Materialize.css.
                                </b-card-text>
                                <div>
                                    <b-button block class="mb-2" href="#" variant="success" v-if="theme === 'matjek'">
                                        <i class="far fa-check-circle"></i> Selected Theme
                                    </b-button>
                                    <b-button block class="mb-2" href="#" variant="primary" v-on:click="select_theme('matjek')" v-else>
                                        <i class="far fa-square"></i> Select Theme
                                    </b-button>
                                </div>
                                <b-button-group block style="width: 100%">
                                    <b-button href="https://shawnteoh.github.io/matjek/" target="_blank" variant="secondary">
                                        <i class="fas fa-external-link-alt"></i> Demo
                                    </b-button>
                                    <b-button href="https://github.com/ShawnTeoh/matjek" target="_blank" variant="secondary">
                                        <i class="fas fa-info-circle"></i> More Info
                                    </b-button>
                                </b-button-group>
                            </b-card>
                            <!-- Hacker-Blog theme -->
                            <b-card title="hacker-blog" :img-src="require('@/assets/themes/hacker-blog.png')" img-alt="Hacker-Blog" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                                <b-card-text>
                                    A high-tech hacker-themed blog.
                                </b-card-text>
                                <div>
                                    <b-button block class="mb-2" href="#" variant="success" v-if="theme === 'hacker-blog'">
                                        <i class="far fa-check-circle"></i> Selected Theme
                                    </b-button>
                                    <b-button block class="mb-2" href="#" variant="primary" v-on:click="select_theme('hacker-blog')" v-else>
                                        <i class="far fa-square"></i> Select Theme
                                    </b-button>
                                </div>
                                <b-button-group block style="width: 100%">
                                    <b-button href="https://ashishchaudhary.in/hacker-blog/" target="_blank" variant="secondary">
                                        <i class="fas fa-external-link-alt"></i> Demo
                                    </b-button>
                                    <b-button href="https://github.com/tocttou/hacker-blog" target="_blank" variant="secondary">
                                        <i class="fas fa-info-circle"></i> More Info
                                    </b-button>
                                </b-button-group>
                            </b-card>
                            <!-- Leaf theme -->
                            <b-card title="Leaf" :img-src="require('@/assets/themes/leaf.png')" img-alt="Leaf" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                                <b-card-text>
                                    A simple clean theme designed for those who love dark sites.
                                </b-card-text>
                                <div>
                                    <b-button block class="mb-2" href="#" variant="success" v-if="theme === 'leaf'">
                                        <i class="far fa-check-circle"></i> Selected Theme
                                    </b-button>
                                    <b-button block class="mb-2" href="#" variant="primary" v-on:click="select_theme('leaf')" v-else>
                                        <i class="far fa-square"></i> Select Theme
                                    </b-button>
                                </div>
                                <b-button-group block style="width: 100%">
                                    <b-button href="https://supunkavinda.github.io/jekyll-theme-leaf/welcome-to-jekyll" target="_blank" variant="secondary">
                                        <i class="fas fa-external-link-alt"></i> Demo
                                    </b-button>
                                    <b-button href="https://github.com/SupunKavinda/jekyll-theme-leaf" target="_blank" variant="secondary">
                                        <i class="fas fa-info-circle"></i> More Info
                                    </b-button>
                                </b-button-group>
                            </b-card>
                            <!-- Emerald theme -->
                            <b-card title="Emerald" :img-src="require('@/assets/themes/emerald.png')" img-alt="Emerald" img-top tag="article" style="max-width: 20rem;" class="mb-2">
                                <b-card-text>
                                    A clear theme for those who want a blog ready to use, focused on the content and mobile-first.
                                </b-card-text>
                                <div>
                                    <b-button block class="mb-2" href="#" variant="success" v-if="theme === 'emerald'">
                                        <i class="far fa-check-circle"></i> Selected Theme
                                    </b-button>
                                    <b-button block class="mb-2" href="#" variant="primary" v-on:click="select_theme('emerald')" v-else>
                                        <i class="far fa-square"></i> Select Theme
                                    </b-button>
                                </div>
                                <b-button-group block style="width: 100%">
                                    <b-button href="https://www.jacoporabolini.com/emerald/" target="_blank" variant="secondary">
                                        <i class="fas fa-external-link-alt"></i> Demo
                                    </b-button>
                                    <b-button href="https://github.com/KingFelix/emerald" target="_blank" variant="secondary">
                                        <i class="fas fa-info-circle"></i> More Info
                                    </b-button>
                                </b-button-group>
                            </b-card>
                        </div>
                        <hr />
                    </div>
                    <div v-if="theme">
                        <b-alert style="text-align: center" show variant="info">
                            <i class="fas fa-info-circle"></i> You can always modify your site configuration later, this is purely optional.
                        </b-alert>
                        <h4>Site Configuration</h4>
                        <codemirror ref="cmEditor" v-model="config_yaml" :options="cmOptions" />
                        <hr />
                    </div>
                    <div style="width: 100%">
                        <b-button class="mr-2 float-left" size="lg" variant="secondary" v-on:click="back_to_site">
                            <i class="fas fa-arrow-left"></i> Go Back to Sites
                        </b-button>
                        <b-button class="float-right" type="submit" size="lg" variant="primary" :disabled="!form_validation">
                            <i class="fas fa-plus"></i> Create new site
                        </b-button>
                    </div>
                </b-form>
            </b-card>
        </b-overlay>
    </div>
</template>
<script>
import api from '../libs/api.js';

export default {
    name: 'CreateNewSite',
    props: {},
    data() {
        return {
            loading: false,
            theme: null,
            subdomain: '',
            subdomain_error: '',
            is_valid: false,
            subdomain_exists: false,
            config_yaml: '',
            cmOptions: {
                tabSize: 2,
                mode: 'text/x-yaml',
                theme: 'monokai',
                lineNumbers: true,
                line: true,
                lint: true
            },
        }
    },
    methods: {
        async check_subdomain() {
            if (this.subdomain === '') {
                return
            }

            const subdomain_exists = await api.subdomain_exists(this.subdomain);

            if (subdomain_exists) {
                this.subdomain_exists = true;
                this.update_subdomain_form_error('Oops, sorry. That subdomain already exists, please choose another one.');
                return
            }

            this.subdomain_exists = false;
        },
        update_subdomain_form_error(error_text) {
            this.subdomain_error = error_text;
            this.set_is_form_valid(false);
        },
        set_is_form_valid(valid_bool) {
            this.is_valid = valid_bool;
        },
        async on_form_submit(evt) {
            evt.preventDefault();
            this.loading = true;

            // Create the new site
            const site_creation_result = await api.create_new_site(
                this.subdomain,
                this.theme
            );
            const new_site_id = site_creation_result.site_id;

            // Set the new site's config
            await api.set_site_config(
                new_site_id,
                this.config_yaml
            );

            this.$bvToast.toast('Your new site was created successfully.', {
                title: 'New Site Created',
                variant: 'success',
                solid: false
            });

            this.loading = false;

            // Scroll to top of page.
            window.scrollTo(0, 0);

            this.$router.push('/created-new-site-successfully');
        },
        back_to_site() {
            this.$router.push('/sites');
        },
        async select_theme(theme) {
            this.loading = true;
            // Pull default config for site theme
            const theme_result = await api.get_theme_default_config(
                theme
            );
            this.config_yaml = theme_result.config_yaml;
            this.theme = theme;
            this.loading = false;
        },
    },
    computed: {
        _form_validation() {
            if (this.subdomain_exists) {
                return false;
            }

            if (!this._subdomain_valid) {
                return false;
            }

            if (!this.theme) {
                return false;
            }

            return true;
        },
        _subdomain_valid() {
            if (this.subdomain.length === 0) {
                this.update_subdomain_form_error('Please specify a DocPusher subdomain to use for your new website.');
                return false;
            }

            if (this.subdomain.length <= 4) {
                this.update_subdomain_form_error('That subdomain is too short, please try something longer.');
                return false;
            }

            if (this.subdomain.length >= 64) {
                this.update_subdomain_form_error('That subdomain is too long, try something shorter.');
                return false;
            }

            if (/^[a-z0-9]+$/g.test(this.subdomain) !== true) {
                this.update_subdomain_form_error('Invalid subdomain characters, please use only numbers and lowercase letters.');
                return false;
            }

            if (this.subdomain_exists) {
                this.update_subdomain_form_error('That subdomain is taken, please choose another.');
                return false;
            }

            this.update_subdomain_form_error(null);
            return true;
        },
        form_validation() {
            const result = this._form_validation;
            this.set_is_form_valid(result);
            return result;
        }
    },
    watch: {
        // Force lowercase for entered in characters for text input
        subdomain: function(input_subdomain) {
            this.subdomain = input_subdomain.toLowerCase();
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-img-top {
    max-width: 300px;
    max-height: 150px;

}
</style>